import type { VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'vue';

import { cva } from 'class-variance-authority';

export { default as BrokerAvatar } from './BrokerAvatar.vue';

export type BrokerAvatarProps = {
	class?: HTMLAttributes['class'];
	avatarFallbackClass?: HTMLAttributes['class'];
	avatarShape?: AvatarVariants['shape'];
	companyAvatarFallbackClass?: HTMLAttributes['class'];
	companyAvatarShape?: AvatarCompanyVariants['shape'];
	border?: AvatarVariants['border'];
	showCompanyAvatar?: boolean;
	isGrayscale?: boolean;
	sizes?: AvatarCompanyVariants['sizes'];
	brokerSrc?: string | null; // Esta prop é provisória
	companySrc?: string | null; // Esta prop é provisória
	initials?: string | null;
	brokerName?: string | null;
	companyName?: string | null;
};

export const avatarVariant = cva(
	'inline-flex size-full shrink-0 select-none items-center justify-center overflow-hidden text-4xl font-normal text-primary transition-all duration-300',
	{
		variants: {
			border: {
				true: 'border-4 border-white',
				false: ''
			},
			shape: {
				circle: 'rounded-full',
				square: ''
			},
			isGrayscale: {
				true: 'grayscale',
				false: ''
			}
		},
		defaultVariants: {
			isGrayscale: false,
			shape: 'circle',
			border: false
		}
	}
);

export const companyAvatarVariant = cva(
	'absolute inline-flex shrink-0 select-none items-center justify-center overflow-hidden bg-primary font-normal text-white',
	{
		variants: {
			sizes: {
				linear: 'left-2/3 size-full',
				overflowRight: '-right-2 bottom-1 size-[38%]',
				containedRight: 'bottom-3 right-3 size-10'
			},
			shape: {
				circle: 'rounded-full',
				square: 'rounded-md'
			}
		},
		defaultVariants: {
			sizes: 'overflowRight',
			shape: 'circle'
		}
	}
);

export type AvatarVariants = VariantProps<typeof avatarVariant>;
export type AvatarCompanyVariants = VariantProps<typeof companyAvatarVariant>;
